/* eslint-disable no-console */
import getWindow from './dom/getWindow';

const LOG_LEVELS = {
  error: 'error',
  exception: 'exception',
  info: 'info',
  warning: 'warning',
};
const window = getWindow();
const hostname = window?.location?.hostname || '';
const LOGGER_URL = `https://logger.goeuro.com/transfer-page-system`;
const isQA = hostname.includes('.ninja');
const isLive = !isQA && (hostname.includes('goeuro.') || hostname.includes('omio.'));
const facility = isLive ? 'live' : 'test';

declare global {
  interface NetworkInformation {
    readonly type:
      | 'bluetooth'
      | 'cellular'
      | 'ethernet'
      | 'mixed'
      | 'none'
      | 'other'
      | 'unknown'
      | 'wifi';
    readonly effectiveType?: 'slow-2g' | '2g' | '3g' | '4g';
  }

  interface Navigator {
    readonly connection: NetworkInformation;
    readonly mozConnection?: NetworkInformation;
    readonly webkitConnection?: NetworkInformation;
  }
}

interface Kv {
  [key: string]: string | number | boolean | null | undefined | Kv;
}

const sendData = (data: any) => {
  if (!isLive) return;

  const timestamp = new Date();

  const payload: Kv = {
    facility,
    log_level: LOG_LEVELS.warning,
    url: window?.location?.href || '',
    client: 'transfer-page-system',
    log_package: 'transfer-page-system',
    log_version: 1,
    timestamp_dt: timestamp.toUTCString(),
    ...data,
  };

  const currentNavigator: Navigator | null | undefined = window?.navigator;

  const connection: NetworkInformation | null | undefined =
    currentNavigator?.connection ||
    currentNavigator?.mozConnection ||
    currentNavigator?.webkitConnection;

  payload.connection_Type_s = connection?.type;
  payload.connection_EffectiveType_s = connection?.effectiveType;

  if (data.log_level === LOG_LEVELS.error || data.log_level === LOG_LEVELS.exception) {
    payload.browser_userAgent_s = currentNavigator?.userAgent;
    payload.browser_platform_s = currentNavigator?.platform;
  }

  const body = JSON.stringify(payload);

  // sendBeacon survives page navigation (e.g. logs fired right before window.location.replace).
  // Fall back to XHR for environments where sendBeacon is unavailable.
  // Return value of sendBeacon is intentionally ignored — delivery is best-effort.
  if (currentNavigator?.sendBeacon) {
    currentNavigator.sendBeacon(LOGGER_URL, new Blob([body], { type: 'application/json' }));
  } else {
    const http = new XMLHttpRequest();
    http.open('POST', LOGGER_URL, true);
    http.setRequestHeader('Content-Type', 'application/json');
    http.send(body);
  }
};

const makeLogger =
  (level: string) =>
  (value: any, payload: any = {}) => {
    let message: string;
    let stack = '';

    if (value.stack) {
      message = value.message;
      stack = value.stack || '';
    } else {
      message = String(value);
    }

    const data = {
      message,
      stack,
      ...payload,
      log_level: level,
    };

    if (process.env.NODE_ENV === 'test') {
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      console.log('logger: ', data);
    }

    sendData(data);
  };

export const logInfo = makeLogger(LOG_LEVELS.info);
export const logException = makeLogger(LOG_LEVELS.exception);
export const logWarning = makeLogger(LOG_LEVELS.warning);
export const logError = makeLogger(LOG_LEVELS.error);
